/**
 * Cover image for a news card, with a branded fallback.
 *
 * Articles are often published before a photo is ready, which used to leave a
 * flat grey rectangle in the card. Mirrors the NRM site's treatment: when there
 * is no cover image we show the ISPS mark as a faint watermark centred on a warm
 * gradient, sized to the mark (never stretched to fill the slot). The logo is
 * decorative — the headline underneath already names the article — so it carries
 * an empty alt and aria-hidden and is skipped by screen readers.
 */
interface NewsCoverProps {
  /** Absolute URL of the article's cover image, when it has one. */
  src?: string | null;
  /** Article headline — the alt text for a real cover image. */
  alt: string;
  /** Extra classes for the real <img> only (e.g. the card's hover zoom). */
  imgClassName?: string;
}

const FALLBACK_LOGO = '/isps_logo2.png';

export function NewsCover({ src, alt, imgClassName = '' }: NewsCoverProps) {
  if (src) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={src}
        alt={alt}
        className={`h-full w-full object-cover ${imgClassName}`.trim()}
      />
    );
  }

  return (
    <span className="grid h-full w-full place-items-center bg-gradient-to-br from-isps-gold-50 to-isps-gold-100">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={FALLBACK_LOGO}
        alt=""
        aria-hidden="true"
        className="w-[38%] max-w-[92px] object-contain opacity-25"
      />
    </span>
  );
}
